/**
 * Navigate to the destination for a notification action path.
 * Supports client dashboard sub-views via ?view= query param.
 */
/**
 * Navigate to the destination for a notification action path.
 * Supports client dashboard sub-views via ?view= query param.
 * Extra params (e.g. ?video=) are kept so the target view can open the entity.
 */
export function navigateFromNotificationAction(navigate, actionPath, { onViewChange } = {}) {
  if (!actionPath || !navigate) return false;

  try {
    const url = new URL(actionPath, window.location.origin);
    const view = url.searchParams.get('view');
    const next = `${url.pathname}${url.search}${url.hash}`;

    if (view && onViewChange && url.pathname === '/dashboard') {
      onViewChange(view);
      navigate(next, { replace: true });
      return true;
    }

    navigate(next);
    return true;
  } catch {
    navigate(actionPath);
    return true;
  }
}

export const CLIENT_NOTIFICATION_VIEWS = new Set([
  'dashboard',
  'rewards',
  'giftsInTransit',
  'contacts',
  'referrals',
  'analytics',
  'settings',
  'club',
  'promotions',
  'videoHub',
]);
